var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-snackbar',{attrs:{"color":_vm.color,"timeout":_vm.timer,"min-width":_vm.minWidth,"bottom":"","right":""},model:{value:(_vm.isVisible),callback:function ($$v) {_vm.isVisible=$$v},expression:"isVisible"}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]),_c('span',{staticClass:"text-caption"},[_vm._v(_vm._s(_vm.message))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }